import React, { useMemo } from 'react';
import isEmpty from 'lodash/fp/isEmpty';
import map from 'lodash/fp/map';
import { sumBy, upperCase } from 'lodash';
import PropTypes from 'prop-types';
import List from '../../../components/list/List';
import { SMART_SELECTION_DELIVERY_METHOD } from '../../../constants/product';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff } from '../../../utilities/user';
import classNames from 'classnames';
export var InvoiceTotal = function(param) {
    var membershipPriceId = param.membershipPriceId, currentUser = param.currentUser, quote = param.quote, selectedMembership = param.selectedMembership, _param_subtotalText = param.subtotalText, subtotalText = _param_subtotalText === void 0 ? "".concat(upperCase(text('buyNow')), " ").concat(text('subtotal')) : _param_subtotalText, _param_grandTotalText = param.grandTotalText, grandTotalText = _param_grandTotalText === void 0 ? "".concat(upperCase(text('buyNow')), " ").concat(text('total')) : _param_grandTotalText, _param_isApproximate = param.isApproximate, isApproximate = _param_isApproximate === void 0 ? false : _param_isApproximate;
    var membershipGST = sumBy(selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.taxes, function(tax) {
        return tax.price.extra;
    });
    var membershipSubtotal = (selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.subtotal) || 0;
    var membershipGrandTotal = (selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.grand_total) || 0;
    var hasMembershipOpted = isMembershipPriceId(membershipPriceId) && !isStaff(currentUser.role);
    var otherDiscountsSubtotal = sumBy(quote === null || quote === void 0 ? void 0 : quote.discounts, function(discount) {
        return discount.price.subtotal;
    });
    var otherDiscountsGSTtotal = sumBy(quote === null || quote === void 0 ? void 0 : quote.discounts, function(discount) {
        return discount.price.gst;
    });
    var otherGST = membershipGST - otherDiscountsGSTtotal;
    var chargesTotalDiscount = useMemo(function() {
        return(// Compute discounts for w/ BUY NOW DATA only
        quote === null || quote === void 0 ? void 0 : quote.charges.reduce(function(totalChargesDiscount, charge) {
            var discounts = (hasMembershipOpted ? charge.member_discounts_preview : charge.discounts) || [];
            return totalChargesDiscount + discounts.reduce(function(totalDiscount, discount) {
                if (charge.details.delivery_method === SMART_SELECTION_DELIVERY_METHOD.MANUAL) {
                    return 0;
                }
                return totalDiscount + discount.price.discount;
            }, 0);
        }, 0));
    }, [
        hasMembershipOpted,
        quote === null || quote === void 0 ? void 0 : quote.charges
    ]);
    return !isEmpty(quote) && !isEmpty(currentUser) ? /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "InvoiceTotal"
    }, /*#__PURE__*/ React.createElement(List.Item, {
        description: text('discounts'),
        value: "-".concat(formatCurrency(chargesTotalDiscount + otherDiscountsSubtotal, quote.currency.name, quote.currency.scale_factor, {}, true)),
        key: "invoice-discounts",
        className: "discounts"
    }), /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        className: classNames({
            isApproximate: isApproximate
        }),
        description: subtotalText,
        value: formatCurrency(hasMembershipOpted ? quote.price.member_subtotal + membershipSubtotal - otherDiscountsSubtotal : quote.price.subtotal + membershipSubtotal - otherDiscountsSubtotal, quote.currency.name, quote.currency.scale_factor, {}, true),
        key: "invoice-subtotal"
    }), map(function(tax, i) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            className: classNames({
                isApproximate: isApproximate
            }),
            key: i,
            description: tax.display_name,
            value: formatCurrency(tax.price.extra + otherGST, quote.currency.name, quote.currency.scale_factor, {}, true)
        });
    })(hasMembershipOpted ? quote.member_taxes : quote.taxes), /*#__PURE__*/ React.createElement(List.Item, {
        className: classNames({
            isApproximate: isApproximate
        }),
        isHighlighted: true,
        description: grandTotalText,
        key: "invoice-total",
        value: formatCurrency(hasMembershipOpted ? quote.price.member_grand_total + membershipGrandTotal : quote.price.grand_total + membershipGrandTotal, quote.currency.name, quote.currency.scale_factor, {}, true)
    }))) : null;
};
InvoiceTotal.propTypes = {
    membershipPriceId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    currentUser: PropTypes.object,
    quote: PropTypes.object,
    selectedMembership: PropTypes.object,
    subtotalText: PropTypes.string,
    grandTotalText: PropTypes.string,
    isApproximate: PropTypes.bool
};
